import useScrollTop from 'hooks/useScrollTop'
import React, { useEffect } from 'react'
import SubFooter from 'organisms/subFooter'
import Banner from './banner'
import Application from './application'
import EnableEcosystem from './enable_ecosystem'

export default function GeneralNonwoven() {
  const scrollTop = useScrollTop()

  useEffect(() => {
    scrollTop()
  }, [])
  return (
    <div className="nonwoven-page-wrapper">
      <Banner />
      <EnableEcosystem />
      <Application />
      <SubFooter
        title="Looking for <strong class='font-semibold'>customised <br class='md:block hidden' /> nonwoven</strong> solutions?"
        btn={{ text: 'Contact us', target: '/contact-us' }}
        className="bg-[url('assets/general_nonwoven/subfooter.jpg')] bg-center"
      />
    </div>
  )
}
